import Admin from "../Admin";
import React from "react";
import CardAdminDiagnosisCodeGeneral from "../../../Component/Card/Admin/DiagnosisCode/CardAdminDiagnosisCodeGeneral";
import PageHeader from "../../../Component/PageHeader";
import MUIButton from "@mui/material/Button";
import MUIDeleteIcon from "@mui/icons-material/Delete";
import MUISaveButton from "@mui/icons-material/Save";
import MUILoadingButton from "@mui/lab/LoadingButton";
import Menu from "../../../Component/Menu";
import DialogConfirm from "../../../Component/Dialog/DialogConfirm";
import MUIMenuItem from '@mui/material/MenuItem';
import MUIListItemIcon from '@mui/material/ListItemIcon';
import DiagnosisCodeService from "../../../Seating/Security/DiagnosisCodeService/diagnosisCodeService";

import Validator from "../../../Utility/Validator";

import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";

export default class DiagnosisCodeCreateEdit extends Admin {
    constructor(props) {
        super(props);

        this.state.diagnosisCode = null;
        this.state.isProcessing = false;
        this.state.isUpdate = !!props.match.params.id;
        this.state.confirmDialogOpen = false;
        this.state.validationIssues = {};
    }

    afterComponentDidMount() {
        const diagnosisCodeId = this.props.match.params.id ? +this.props.match.params.id : null;

        if (diagnosisCodeId !== null) {
            DiagnosisCodeService.getDiagnosisCodeById(diagnosisCodeId)
                .then((diagnosisCode) => {
                    this.setState({
                        diagnosisCode: diagnosisCode,
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        }
    }

    async createDiagnosisCode() {
        this.setState({ isProcessing: true });

        return DiagnosisCodeService.createDiagnosisCode(this.state.diagnosisCode)
            .then(diagnosisCode => {
                this.context.updateIndexed("diagnosisCodesIndexed", diagnosisCode);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Diagnosis Code created successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Error creating Diagnosis Code.", { variant: "error" });
                this.setState({ isProcessing: false });
            });
    }

    async updateDiagnosisCode() {
        this.setState({ isProcessing: true });

        return DiagnosisCodeService.updateDiagnosisCode(this.state.diagnosisCode)
            .then(diagnosisCode => {
                this.context.updateIndexed("diagnosisCodesIndexed", diagnosisCode);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Diagnosis Code updated successfully!", { variant: "success" });
            })
            .catch(err => {
                console.log(err);
                NotistackEnqueueSnackbar("Error updating Diagnosis Code.", { variant: "error" });
                this.setState({ isProcessing: false });
            });
    }

    async deleteDiagnosisCode() {
        this.setState({ isProcessing: true });

        return DiagnosisCodeService.deleteDiagnosisCode(this.state.diagnosisCode.id)
            .then(() => {
                this.context.deleteIndexed("diagnosisCodesIndexed", this.state.diagnosisCode.id);
                this.props.history.goBack();
                NotistackEnqueueSnackbar("Diagnosis Code deleted successfully!", { variant: "success" });
            })
            .catch((err) => {
                console.log(err);
                NotistackEnqueueSnackbar("Error deleting Diagnosis Code.", { variant: "error" });
                this.setState({ confirmDialogOpen: false });
            });
    }

    renderContent() {
        const handleChange = (diagnosisCode) => {
            this.setState({
                diagnosisCode: {
                    ...this.state.diagnosisCode,
                    ...diagnosisCode,
                },
            });
        };

        return (
            <>
                <CardAdminDiagnosisCodeGeneral
                    diagnosisCode={this.state.diagnosisCode}
                    onChange={handleChange.bind(this)}
                    validationIssues={this.state.validationIssues}
                />
                <DialogConfirm
                    open={this.state.confirmDialogOpen}
                    onClose={() => this.setState({ confirmDialogOpen: false })}
                    onConfirm={() => this.deleteDiagnosisCode()}
                    text="Are you sure you want to delete this Diagnosis Code? This cannot be undone."
                    header="Delete Diagnosis Code"
                    loading={this.state.isProcessing}
                />
            </>
        );
    }

    renderHeader() {
        let title;
        const buttonText = this.state.isUpdate ? "Save" : "Create";

        if (!this.state.isUpdate) {
            title = 'Create Diagnosis Code';
        } else {
            title = 'Edit Diagnosis Code';
        }

        const handleClickBack = () => {
            this.props.history.goBack();
        };

        const handleClickSave = () => {
            const validationIssues = Validator.validate(
                this.state.diagnosisCode,
                { code: { 'required': true } }
            );

            this.setState({ validationIssues });

            if (Object.keys(validationIssues).length === 0) {
                if (this.state.isUpdate) {
                    this.updateDiagnosisCode();
                } else {
                    this.createDiagnosisCode();
                }
            } else {
                NotistackEnqueueSnackbar("Please correct the displayed issues.", { variant: "error" });
            }
        };

        const handleDelete = () => {
            this.setState({ confirmDialogOpen: true });
        };

        const buttons = [
            (<MUIButton onClick={handleClickBack}>Back</MUIButton>),
            (
                <MUILoadingButton
                    loading={this.state.isProcessing}
                    loadingPosition="start"
                    onClick={handleClickSave}
                    variant="contained"
                    startIcon={<MUISaveButton />}>
                    {buttonText}
                </MUILoadingButton>
            )
        ];

        if (this.state.isUpdate) {
            const menuItems = [
                (
                    <MUIMenuItem onClick={handleDelete}>
                        <MUIListItemIcon>
                            <MUIDeleteIcon fontSize="small" />
                        </MUIListItemIcon>
                        Delete
                    </MUIMenuItem>
                )
            ];
            buttons.push((<Menu menuItems={menuItems} />));
        }

        return (
            <PageHeader title={title} buttons={buttons} />
        );
    }
}
